import CartContext from '../../context/CartContext'

const CartSummary = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList} = value
      let total = 0
      cartList.forEach(each => {
        total += each.price * each.quantity
      })

      return (
        <div className="summary-card">
          <h1 className="total">
            Order Total: <span>Rs {total}/-</span>
          </h1>
          <p className="total-items">{cartList.length} Items in cart</p>
          <button type="button" className="total-btn shop-now-btn">
            Checkout
          </button>
        </div>
      )
    }}
  </CartContext.Consumer>
)

export default CartSummary
